import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ← FIX: was missing
import MailList from "../components/mail/MailList";
import MailPreview from "../components/mail/MailPreview";

function MailPage({
  folder,
  mails,
  searchQuery,
  setSearchQuery,
  selectedMailId,
  onSelectMail,
  selectedMail,
  isMobile,
  showMobileList,
  onToggleMobileList,
  loading,
  error,
  externalBlocked,
  starredMap,
  onToggleStar,
  onReply,
  onReplyAll,
  onForward,
  selectedIds = [],
  onToggleSelect,
  onToggleSelectAll,
  onMarkReadSelected,
  onMarkUnreadSelected,
  onStarSelected,
  onUnstarSelected,
  onMoveSelected,
  onDeleteSelected,
  onArchiveSelected,
  onReportSpamSelected,
  onDeleteMail,
  onApplyLabelSelected = () => {},
  onRemoveLabelSelected = () => {},
  onOpenComposeModal, // <-- add this prop
}) {
  const navigate = useNavigate(); // ← FIX: was missing

  const [localMails, setLocalMails] = useState(mails);
  useEffect(() => { setLocalMails(mails); }, [mails]);

  const currentMail = localMails.find(m => m.id === selectedMailId) || null;

  const handleStatusUpdated = (id, newStatus) => {
    setLocalMails(prev => prev.map(m => m.id === id ? { ...m, mailStatus: newStatus } : m));
  };

  // folder navigation — "inbox" maps to root path
  const handleFolderChange = (f) => {
    if (f === "compose") {
      if (onOpenComposeModal) onOpenComposeModal();
      return;
    }
    navigate(`/kmail/${f === "inbox" ? "" : f}`);
  };

  if (loading) return <div className="mail-empty">Loading…</div>;
  if (error)   return <div className="mail-empty">{error}</div>;

  // ── MOBILE ────────────────────────────────────────────────────────────────
  if (isMobile) {
    if (showMobileList) {
      return (
        <MailList
          mails={localMails}
          folder={folder}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          selectedMailId={selectedMailId}
          onSelectMail={onSelectMail}
          starredMap={starredMap}
          onToggleStar={onToggleStar}
          isMobile
          selectedIds={selectedIds}
          onToggleSelect={onToggleSelect}
          onToggleSelectAll={onToggleSelectAll}
          onMarkReadSelected={onMarkReadSelected}
          onMarkUnreadSelected={onMarkUnreadSelected}
          onStarSelected={onStarSelected}
          onUnstarSelected={onUnstarSelected}
          onMoveSelected={onMoveSelected}
          onDeleteSelected={onDeleteSelected}
          onArchiveSelected={onArchiveSelected}
          onReportSpamSelected={onReportSpamSelected}
          onApplyLabelSelected={onApplyLabelSelected}
          onRemoveLabelSelected={onRemoveLabelSelected}
          activeFolder={folder}
          onFolderChange={handleFolderChange}
          onOpenComposeModal={onOpenComposeModal} // <-- pass down
        />
      );
    }

    return (
      <div className="mail-mobile-preview">
        <div className="mail-mobile-header">
          <button className="mail-mobile-back-btn" onClick={() => onToggleMobileList(true)}>
            ← Back
          </button>
        </div>

        <MailPreview
          mail={currentMail}
          onDelete={() => onDeleteMail?.(currentMail?.id)}
          onReply={onReply}
          onReplyAll={onReplyAll}
          onForward={onForward}
          onOpenComposeModal={onOpenComposeModal}
          onStatusUpdated={handleStatusUpdated}
          activeFolder={folder}
          // toolbar props
          mails={localMails}
          selectedIds={selectedIds}
          onToggleSelectAll={onToggleSelectAll}
          onMarkReadSelected={onMarkReadSelected}
          onMarkUnreadSelected={onMarkUnreadSelected}
          onStarSelected={onStarSelected}
          onUnstarSelected={onUnstarSelected}
          onDeleteSelected={onDeleteSelected}
          onArchiveSelected={onArchiveSelected}
          onReportSpamSelected={onReportSpamSelected}
          onApplyLabelSelected={onApplyLabelSelected}
          activeFolder={folder}
          onFolderChange={handleFolderChange}
          isMobile
        />

        <div className="mail-mobile-actions">
          <button className="mail-action-btn" onClick={onReply}>
            <i className="fa-solid fa-reply" style={{ marginRight: 8 }} />Reply
          </button>
          <button className="mail-action-btn" onClick={onForward}>
            <i className="fa-solid fa-share" style={{ marginRight: 8 }} />Forward
          </button>
        </div>
      </div>
    );
  }

  // ── DESKTOP ───────────────────────────────────────────────────────────────
  return (
    <section className="mail-grid">

      <MailList
        mails={localMails}
        folder={folder}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedMailId={selectedMailId}
        onSelectMail={onSelectMail}
        starredMap={starredMap}
        onToggleStar={onToggleStar}
        selectedIds={selectedIds}
        onToggleSelect={onToggleSelect}
        onToggleSelectAll={onToggleSelectAll}
        onMarkReadSelected={onMarkReadSelected}
        onMarkUnreadSelected={onMarkUnreadSelected}
        onStarSelected={onStarSelected}
        onUnstarSelected={onUnstarSelected}
        onMoveSelected={onMoveSelected}
        onDeleteSelected={onDeleteSelected}
        onArchiveSelected={onArchiveSelected}
        onReportSpamSelected={onReportSpamSelected}
        onApplyLabelSelected={onApplyLabelSelected}
        onRemoveLabelSelected={onRemoveLabelSelected}
        activeFolder={folder}
        onFolderChange={handleFolderChange}
        onOpenComposeModal={onOpenComposeModal} // <-- pass down
      />

      <MailPreview
        mail={currentMail}
        onDelete={() => onDeleteMail?.(currentMail?.id)}
        onReply={onReply}
        onReplyAll={onReplyAll}
        onForward={onForward}
        onOpenComposeModal={onOpenComposeModal}
        onStatusUpdated={handleStatusUpdated}
        activeFolder={folder}
        // toolbar props
        mails={localMails}
        selectedIds={selectedIds}
        onToggleSelectAll={onToggleSelectAll}
        onMarkReadSelected={onMarkReadSelected}
        onMarkUnreadSelected={onMarkUnreadSelected}
        onStarSelected={onStarSelected}
        onUnstarSelected={onUnstarSelected}
        onDeleteSelected={onDeleteSelected}
        onArchiveSelected={onArchiveSelected}
        onReportSpamSelected={onReportSpamSelected}
        onApplyLabelSelected={onApplyLabelSelected}
        activeFolder={folder}
        onFolderChange={handleFolderChange}
        isMobile={false}
      />

    </section>
  );
}

export default MailPage;
